"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _react = _interopRequireWildcard(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

require("./_status-bar.scss");

function StatusBar(_ref) {
  var balance = _ref.balance,
      total = _ref.total,
      result = balance / total,
      width = Number.isNaN(+result) ? 0 : "".concat(100 * result, "%");
  return _react["default"].createElement("div", {
    className: "credits-status-bar"
  }, _react["default"].createElement("div", {
    className: "credits-status-bar__bar"
  }, _react["default"].createElement("div", {
    className: "credits-status-bar__progress",
    style: {
      width: width
    }
  })));
}

var _default = (0, _react.memo)(StatusBar);

exports["default"] = _default;